module.exports = __webpack_public_path__ + "static/media/p12.ae2a72e3.webp";